import React, { useEffect, useRef, useState } from 'react';
import './ShootingStars.css';

const randomFromRange = (min, max) => Math.random() * (max - min) + min;

/**
 * Meteors only — static star layers removed in favor of the global WebGPU background.
 */
const ShootingStars = () => {
  const [meteors, setMeteors] = useState([]);
  const meteorIdRef = useRef(0);
  const spawnTimeoutRef = useRef(null);
  const removalTimeoutsRef = useRef([]);

  useEffect(() => {
    const createMeteor = () => {
      const id = meteorIdRef.current++;
      const startX = randomFromRange(window.innerWidth * 0.62, window.innerWidth * 1.08);
      const startY = randomFromRange(-60, window.innerHeight * 0.32);
      const travelXPx = randomFromRange(-window.innerWidth * 0.62, -window.innerWidth * 0.4);
      const travelYPx = randomFromRange(window.innerHeight * 0.28, window.innerHeight * 0.5);
      const angle = (Math.atan2(travelYPx, travelXPx) * 180) / Math.PI;
      const distance = Math.hypot(travelXPx, travelYPx);
      const durationMs = randomFromRange(1500, 2300);

      const meteor = {
        key: `meteor-${id}`,
        top: startY,
        left: startX,
        durationMs,
        length: randomFromRange(120, 210),
        angle,
        distance
      };

      setMeteors((prev) => [...prev, meteor]);

      const removalTimeout = window.setTimeout(() => {
        setMeteors((prev) => prev.filter((item) => item.key !== meteor.key));
      }, durationMs + 220);
      removalTimeoutsRef.current.push(removalTimeout);
    };

    const scheduleNextMeteor = () => {
      const nextInMs = randomFromRange(7000, 14000);
      spawnTimeoutRef.current = window.setTimeout(() => {
        createMeteor();
        scheduleNextMeteor();
      }, nextInMs);
    };

    scheduleNextMeteor();

    return () => {
      if (spawnTimeoutRef.current) {
        window.clearTimeout(spawnTimeoutRef.current);
      }
      removalTimeoutsRef.current.forEach((timeoutId) => window.clearTimeout(timeoutId));
    };
  }, []);

  return (
    <div className="shootingStars" aria-hidden="true">
      <div className="shootingStars__layer">
        {meteors.map((meteor) => (
          <span
            key={meteor.key}
            className="shootingStars__meteor"
            style={{
              top: `${meteor.top}px`,
              left: `${meteor.left}px`,
              '--meteor-duration': `${meteor.durationMs}ms`,
              '--meteor-length': `${meteor.length}px`,
              '--meteor-angle': `${meteor.angle}deg`,
              '--meteor-distance': `${meteor.distance}px`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ShootingStars;
